import z from "zod";
import { intl } from "LocaleWrapper";
import { SailingReportRangeType } from "./SailingReportUtils";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { labelSelectOptionSchema } from "view/labels/utils/label.schema";
import { FuelType } from "__generated__/enums";
import { shipSelectOptionSchema } from "view/ships/utils/ship.schema";

export const sailingReportSchema = z.object({
	id: z.number().nullable(),
	rangeType: z.enum(SailingReportRangeType),
	ship: ZodSchema.requiredField(shipSelectOptionSchema),
	voyage: z.object({ id: z.number(), voyageNumber: z.string() }).nullable(),
	fromTime: z.number().nullable(),
	toTime: z.number().nullable(),
	remark: z.string().max(255),
	sailHours: z.number().max(99999).nullable(),
	geofenceSailMinutes: z.number().nullable().transform(() => undefined),
	sailedDistanceKm: z.number().nullable().transform(() => undefined),
	bunkeringBefore: z.int32().nullable(),
	bunkered: z.int32().nullable(),
	bunkeringAfter: z.int32().nullable(),
	fuelType: z.enum(FuelType).nullable(),
	usageAmount: z.int32().nullable(),
	label: labelSelectOptionSchema.nullable(),
	logs: z.array(z.object({
		id: z.number().nullable(),
		allDay: z.boolean(),
		startDate: z.number().nullable(),
		endDate: z.number().nullable(),
		remark: z.string(),
		startLocation: z.string(),
		startPosition: z.object({
			latitude: z.number().nullable(),
			longitude: z.number().nullable(),
		}),
		endLocation: z.string(),
		endPosition: z.object({
			latitude: z.number().nullable(),
			longitude: z.number().nullable(),
		}),
	})),
}).superRefine((data, ctx) => {
	if (data.rangeType === SailingReportRangeType.Voyage && !data.voyage) {
		ctx.addIssue({
			code: "custom",
			message: intl.formatMessage({ id: "REQUIRED" }),
			path: [ "voyage" ],
		});
	}

	if (data.rangeType === SailingReportRangeType.Date && !data.fromTime) {
		ctx.addIssue({
			code: "custom",
			message: intl.formatMessage({ id: "REQUIRED" }),
			path: [ "fromTime" ],
		});
	}

	if (data.rangeType === SailingReportRangeType.Date && !data.toTime) {
		ctx.addIssue({
			code: "custom",
			message: intl.formatMessage({ id: "REQUIRED" }),
			path: [ "toTime" ],
		});
	}
});

export type SailingReportSchemaInput = z.input<typeof sailingReportSchema>;
export type SailingReportSchemaOutput = z.output<typeof sailingReportSchema>;

